import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
import app from '../../main' // import the instance
import axios from 'axios' // remove comment if yu needed
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Customers', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  customers: [],
  syncro: false,
  canSync: false
}

const mutations = {
  ...crud.mutations,
  SET_SYNCRO (state, payload) {
    state.syncro = payload
  },
  SET_CAN_SYNC (state, payload) {
    state.canSync = payload
  },
  UPDATE_CUSTOMER (state, updatedCustomer) {
    const index = state.customers.findIndex(customer => customer.id === updatedCustomer.id)
    if (index !== -1) {
      state.customers.splice(index, 1, updatedCustomer)
    }
  }
}

const actions = {
  ...crud.actions,
  async checkSyncro ({ commit }) {
    app.$Progress.start()
    try {
      const response = await axios.get(`/contpaq/syncro`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        const data = typeof response.data === 'object' ? null : response.data

        const actions = {
          false: () => {
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.syncro' }, { root: true })
          },
          true: () => {
            commit('SET_SYNCRO', data)
          },
          null: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.contpaq', text: 'errors.syncro_request_error' }, { root: true })
          },
          default: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.connection_error' }, { root: true })
          }
        };

        (actions[data] || actions.default)()
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async syncCustomers ({ commit }) {
    app.$Progress.start()
    try {
      const response = await axios.get(`contpaq/customers`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async getQuantityJobs ({ commit }) {
    try {
      const response = await axios.get(`contpaq/jobs/quantity`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        return response.data
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  setCanSync ({ commit }, payload) {
    commit('SET_CAN_SYNC', payload)
  },
  async saveTrackingGuideFiles ({ commit }, payload) {
    let formData = new FormData()
    payload.files.forEach(file => {
      formData.append('files[]', file)
    })
    formData.append('form', JSON.stringify({ ...payload }))

    app.$Progress.start()
    try {
      const response = await axios.post(`customers/${payload.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-HTTP-Method-Override': 'PUT'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'Logo', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('UPDATE_CUSTOMER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  customers: state => state.customers,
  syncro: state => state.syncro,
  canSync: state => state.canSync
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
